import React from "react";
import "./ResumoProfessores.css";

const ResumoProfessores = ({ professores = [] }) => {
  const total = professores.length;

  const totalMasculinos = professores.filter(
    (prof) => prof.Genero && prof.Genero.toLowerCase() === "masculino"
  ).length;

  const totalFemininos = professores.filter(
    (prof) => prof.Genero && prof.Genero.toLowerCase() === "feminino"
  ).length;

  return (
    <div className="resumo-professores">
      Total: <span className="total">{total}</span> professores — 
      Masculinos: <span className="masculino">{totalMasculinos}</span> — 
      Femininos: <span className="feminino">{totalFemininos}</span>
    </div>
  );
};

export default ResumoProfessores;
